import { render, staticRenderFns } from "./KeyLearnings.vue?vue&type=template&id=287ae074&"
import script from "./KeyLearnings.vue?vue&type=script&lang=js&"
export * from "./KeyLearnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports